import type { IconSvgObject } from './types';

const PointingLeft01Icon: IconSvgObject = [
  ["path", { d: "M8 4.5H2.5M4.5 2L2 4.5L4.5 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 20H20L17.6892 20.9985C16.2125 21.7056 13.3226 22.6732 11.9618 21.3211C9.81667 19.1895 9.42404 16.2082 9.5 14.5H3.75C2.7835 14.5 2 13.7165 2 12.75C2 11.7835 2.7835 11 3.75 11L14 11L11.6713 8.78341C11.0311 8.05938 11.1372 6.96519 11.9053 6.36948C12.5444 5.87385 13.4534 5.87719 14.0886 6.3775L19.9973 11H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PointingLeft01Icon;
